module.exports = __webpack_public_path__ + "img/question16.84d3c28e.png";